import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { PaymentAdyen } from '../interface/adyen-payment/payment-adyen.interface';
import { PaymentRegistrationResponse } from '../interface/payvision/payment-registration-reponse.interface';
import * as crypto from 'crypto-js';
import { InitiateAdyenPaymentRequest } from '../interface/adyen-payment/initiate-adyen-payment.interface';
@Injectable()
export class AdyenPaymentService {

    constructor(private _http: Http) { }


    getAdyenPaymentForm(paymentRegistrationRequest: PaymentAdyen)
        : Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http.post(ApiUrlConstants.paymentApiUrl + 'payments/adyen-payment-methods', paymentRegistrationRequest, { headers: headers })
        .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }

    initiatePayment(initiateAdyenPayment: InitiateAdyenPaymentRequest): Observable<any> {
        const headers = this.getPaymentHeaders();
        // return this._http.post(ApiUrlConstants.paymentApiUrl + 'payments/initiate-payment', initiateAdyenPayment, { headers: headers });
        return this._http
        .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'payments/initiate-payment')), 
        initiateAdyenPayment, { headers: headers })
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
    } 

    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

    submitAdditionalDetails(data: any): Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http.post(ApiUrlConstants.paymentApiUrl + 'payments/submitAdditionalDetails', data, { headers: headers })
    }
  
}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/adyen-payment.service.ts